import { Box } from '@mui/material';

import { type Course } from 'src/utils/type';

export default function CourseCard ({ course, simple = false }: { course: Course; simple?: boolean; }) {
  return (
    <Box
      sx={{
        padding: '10px',
        boxShadow: '0px 3px 6px #00000029',
        '& .mandatory': {
          marginTop: '15px',
          fontSize: '18px',
          background: '#006EC2',
          padding: '2px 4px',
          display: 'inline-block',
          lineHeight: '17px',
          borderRadius: '2px',
          color: '#FFFFFF',
        },
      }}
    >
      <img
        src={course.thumbnail}
        alt="course-img"
        style={{ objectFit: 'contain', width: '100%', height: '100%', boxShadow: '0px 3px 6px #00000029' }}
      />
      <div style={{ marginTop: '15px', color: '#006EC2', fontSize: '24px', fontWeight: 'bold' }}>
        {course.category1}
      </div>
      <span className="mandatory">Mandatory</span>
      <div style={{ fontSize: '18px', color: '#006EC2', marginTop: '15px' }}>Time Estimate: 5-10mins</div>

      <p style={{ fontSize: '18px', color: '#707070' }}>{course.description}</p>
    </Box>
  );
}
